export var block = function block(centralApi) {
  return {
    index: function index(params) {
      if (params === void 0) {
        params = {};
      }
      return centralApi.get('/block/by-account', {
        params: params
      }).then(function (res) {
        var normalizedData = res;
        if (res.data === undefined) {
          normalizedData = res;
          normalizedData.data = res.blocks;
        }
        return normalizedData;
      });
    },
    post: function post(data) {
      return centralApi.post('/block', data);
    },
    put: function put(data) {
      return centralApi.put('/block', data);
    },
    delete: function _delete(ani, params) {
      return centralApi.delete("/block/".concat(ani), {
        params: params
      });
    }
  };
};